import React, { useState } from "react"
import styles from "./ServiceMedia.module.css"
import YouTube from "react-youtube"
import classNames from "classnames/bind"

const cx = classNames.bind(styles)

const ServiceMedia = ({ image, video, thumbnail }) => {
  const [showThumbnail, setShowThumbnail] = useState(true)

  let ytPlayer
  let nativeMedia

  if (video && !video.includes("youtube")) {
    nativeMedia = (
      <video
        src={video}
        className={styles.introMedia}
        autoPlay
        muted
        loop
        playsInline
      />
    )
  }

  if (image) {
    nativeMedia = <img src={image} className={styles.introMedia} />
  }

  const getPlayer = event => {
    ytPlayer = event.target
  }

  const showVideo = () => {
    setShowThumbnail(false)
    if (ytPlayer) {
      ytPlayer.playVideo()
    }
  }

  return (
    <div className={styles.introMediaContainer} onClick={showVideo}>
      {nativeMedia}
      {!nativeMedia && (
        <div>
          {thumbnail && (
            <img
              src={thumbnail}
              className={cx({
                introThumbnail: true,
                hideThumbnail: !showThumbnail,
              })}
            />
          )}
          <div
            className={cx({
              playButton: true,
              hideThumbnail: !showThumbnail,
            })}
          >
            <img src="/icons/play-button.svg" />
          </div>
          <YouTube
            videoId={video}
            className={styles.introMedia}
            onReady={getPlayer}
          />
        </div>
      )}
    </div>
  )
}

export default ServiceMedia
